var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 15,
    fill: "#828385"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.22,3.8h1.56l3,4.79h0V3.8h1.47v7.13H22.68l-3-4.77h0v4.77H18.22Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28,5.63a2.54,2.54,0,0,1,2.68,2.73A2.54,2.54,0,0,1,28,11.08a2.53,2.53,0,0,1-2.67-2.72A2.54,2.54,0,0,1,28,5.63ZM28,10c1,0,1.26-.82,1.26-1.64S29,6.7,28,6.7s-1.25.83-1.25,1.66S27,10,28,10Z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoFill);
export default __webpack_public_path__ + "static/media/NoFill.dec9baed91dc3f3ee134ce95d377505a.svg";
export { ForwardRef as ReactComponent };